import { IMAGE_TYPE } from "./../../ricos-content";
const getExpandFunction = ({
  helpers,
  config,
  nodeId,
  imageData
}) => {
  const { onExpand, disableExpand } = config;
  if (imageData?.disableExpand === true || disableExpand === true || !onExpand) {
    return;
  }
  return (e) => {
    e.preventDefault();
    helpers.onViewerAction?.(IMAGE_TYPE, "Click", "expand_image");
    onExpand(nodeId);
  };
};
export {
  getExpandFunction
};
//# sourceMappingURL=get-expand-function.js.map
